import _defineProperty from '@babel/runtime/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import { isThemableToken } from '../../util/mappers.util.js';
import { selectIntentColorToken, selectToken } from '../../util/tokenSelector.js';
import { useIntentContext } from '../../contexts/Intent/hooks/useIntentContext.js';
import { useDirectionContext } from '../../contexts/session/Locale.js';
import { useThemeContext } from '../../contexts/session/Theme.js';
import { getTextAlign, getTypographySpacing } from './Typography.mappers.js';

var _excluded = ["variant", "textAlign", "textColor", "lineClamp", "textDecoration", "textDecorationStyle", "interactive", "tag", "display", "children", "fontWeight", "style", "className", "textUnderlineOffset"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var resolveClassName = function resolveClassName(_ref) {
  var interactive = _ref.interactive,
    _ref$oldClass = _ref.oldClass,
    oldClass = _ref$oldClass === void 0 ? '' : _ref$oldClass;
  return interactive === 'none' ? 'ads-non-interactive' : oldClass;
};
var getTextParams = function getTextParams(_ref2) {
  var variant = _ref2.variant,
    textDecoration = _ref2.textDecoration,
    textDecorationStyle = _ref2.textDecorationStyle,
    fontWeight = _ref2.fontWeight,
    textUnderlineOffset = _ref2.textUnderlineOffset;
  var legacyTextParams = variant ? {
    $fontWeight: fontWeight !== null && fontWeight !== void 0 ? fontWeight : variant.fontWeight,
    $lineHeight: variant.lineHeight,
    $fontSize: variant.fontSize,
    $letterSpacing: variant.letterSpacing,
    $textDecoration: variant.textDecoration,
    $textDecorationLine: textDecoration,
    $textDecorationStyle: textDecorationStyle,
    $textTransform: variant.textCase,
    $responsive: variant.responsive,
    $textUnderlineOffset: textUnderlineOffset
  } : {};
  return {
    legacyTextParams: legacyTextParams
  };
};
var useTypography = function useTypography(_ref3) {
  var _ref4;
  var props = _ref3.props,
    ref = _ref3.ref;
  var propVariant = props.variant,
    textAlign = props.textAlign,
    propTextColor = props.textColor,
    lineClamp = props.lineClamp,
    textDecoration = props.textDecoration,
    textDecorationStyle = props.textDecorationStyle,
    interactive = props.interactive,
    tag = props.tag,
    display = props.display,
    children = props.children,
    fontWeight = props.fontWeight,
    style = props.style,
    _props$className = props.className,
    passedClassName = _props$className === void 0 ? '' : _props$className,
    textUnderlineOffset = props.textUnderlineOffset,
    rest = _objectWithoutProperties(props, _excluded);
  var direction = useDirectionContext();
  var theme = useThemeContext();
  var _useIntentContext = useIntentContext(),
    intent = _useIntentContext.intent;
  var textColor = isThemableToken(propTextColor || '') ? selectIntentColorToken(theme.intent, 'text', propTextColor, intent) : selectToken(theme.text, propTextColor);
  var variant = propVariant && selectToken(theme.typography, propVariant);
  var _getTextParams = getTextParams({
      variant: variant,
      textDecoration: textDecoration,
      textDecorationStyle: textDecorationStyle,
      fontWeight: fontWeight,
      textUnderlineOffset: textUnderlineOffset
    }),
    legacyTextParams = _getTextParams.legacyTextParams;
  var finalTextAlign = getTextAlign(direction, textAlign);
  var spacing = getTypographySpacing(props, direction, theme.spacing);
  var ElementTag = (_ref4 = tag !== null && tag !== void 0 ? tag : variant === null || variant === void 0 ? void 0 : variant.tag) !== null && _ref4 !== void 0 ? _ref4 : 'p';
  var passedAndMappedClass = passedClassName;
  var className = resolveClassName({
    interactive: interactive,
    oldClass: passedAndMappedClass
  });
  return {
    ElementTag: ElementTag,
    styledProps: _objectSpread(_objectSpread(_objectSpread(_objectSpread({
      as: tag || (variant === null || variant === void 0 ? void 0 : variant.tag),
      className: className,
      $textColor: textColor,
      $textAlign: finalTextAlign,
      $lineClamp: lineClamp,
      $display: display
    }, legacyTextParams), spacing), rest), {}, {
      style: style,
      ref: ref
    }),
    children: children
  };
};

export { useTypography };
//# sourceMappingURL=useTypography.js.map
